module.exports = __webpack_public_path__ + "media/images/athletes/4338-7de338025ae57770dd1f0fb414b0d6a8.png";